/**
 * A typed date -> ISO ("1949-07-19", what the champisBirthDate field takes),
 * or null when it isn't one. The other way round from formatDate(): day
 * first, then month, then year, separated by anything not a digit
 * ("15.10.2026", "15/10/2026", "15 10 26"), or digits only ("15102026",
 * "190749"). A two-digit year is the latest such year not in the future
 * ("49" -> 1949, "05" -> 2005): these are dates of birth. A day the month
 * doesn't have (31.02) is no date. Copied from champis-exhibitions' own,
 * which reads two-digit years as this century's.
 */
export default function parseDate(text) {
  const trimmed = text.trim();
  const parts = /^\d+$/.test(trimmed) ? trimmed.match(/^(\d{2})(\d{2})(\d{2}|\d{4})$/)?.slice(1) ?? [] : trimmed.split(/\D+/).filter(Boolean);
  if (parts.length !== 3 || parts[2].length !== 2 && parts[2].length !== 4) return null;
  const [day, month, year] = parts.map(Number);
  const thisYear = new Date().getFullYear();
  const fullYear = parts[2].length === 2 ? 2000 + year > thisYear ? 1900 + year : 2000 + year : year;

  // Rolled over (31.02 -> 03.03) if the month hasn't that day.
  const date = new Date(Date.UTC(fullYear, month - 1, day));
  if (date.getUTCFullYear() !== fullYear || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
  return [String(fullYear), String(month).padStart(2, '0'), String(day).padStart(2, '0')].join('-');
}
flarum.reg.add('champis-users', 'forum/utils/parseDate', parseDate);